import { List, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HistoryEvent } from "components/pages/game/HistoryEvent";
import { HistoryEventType } from "models/HistoryEventType";
import React from "react";

interface Props {
  logContent: HistoryEventType[];
}

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0.25),
  backgroundColor: theme.palette.background.paper,
  maxHeight: "100%",
  overflow: "auto",
}));

export const Component: React.FC<Props> = ({ logContent: historyEvents }) => {
  return (
    <StyledPaper elevation={2}>
      <List disablePadding>
        {historyEvents.map((event) => (
          <HistoryEvent event={event} />
        ))}
      </List>
    </StyledPaper>
  );
};

Component.displayName = "HistoryContainer";
